import { gql } from '@apollo/client';

/**
 * Query to get all users in the company/account
 * Returns users with their id, name, email, and role
 */
export const GET_COMPANY_USERS = gql`
  query getCompanyUsers($teamId: String) {
    getCompanyUsers(teamId: $teamId) {
      id
      name
      email
      role
      date
      canEditHomePath
      multiFactorConfig {
        totp
        phone
      }
    }
  }
`;

/**
 * ALL human users in the account (users collection by accountId) — INCLUDES users who belong only to a
 * sub-team, which `getCompanyUsers` (company.users) misses. Admin-only; used by the Group Security
 * member pickers. Backend: user.resolver `accountUsers`.
 */
export const ACCOUNT_USERS_QUERY = gql`
  query accountUsers {
    accountUsers {
      id
      name
      email
    }
  }
`;

/**
 * Query to get all teams in the account
 * Returns teams with their _id, name, description, and createdAt
 */
/**
 * Mutation to log scio3→scio1 switch and update user.scioVersion=1
 */
export const SCIO_SWITCH_LOGS = gql`
  mutation scioSwitchLogs($teamId: String) {
    scioSwitchLogs(teamId: $teamId)
  }
`;

export const SAVE_TEAM = gql`
  mutation SaveTeam($payload: TeamInput!) {
    saveTeam(payload: $payload) {
      _id
      name
    }
  }
`;

export const GET_ALL_TEAMS = gql`
  query getAllTeams($teamId: String, $first: Int, $sort: TeamSort, $ids: [String!]) {
    getAllTeams(teamId: $teamId, first: $first, sort: $sort, ids: $ids) {
      page {
        edges {
          node {
            _id
            name
            description
            createdAt
            isTeamBilling
            purpose
            limitation {
              maxQuantity
              quantity
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
      }
      pageData {
        limit
        offset
      }
    }
  }
`;
